import { Indicator } from '@/components/atoms/Indicator/Indicator';
import { FC } from 'react';
import { getBatteryCapacityRating } from '../../../lib/report';
import { VDPChargingCardWrapper } from '../VDPChargingCardWrapper/VDPChargingCardWrapper';

interface VDPChargingBatteryCapacityCardProps {
  capacity: number | null;
  fuelType: string;
  infoCircle?: boolean;
}
interface ColumnsProps {
  content: (React.ReactNode | null)[];
}

const Columns: FC<ColumnsProps> = ({ content }) => {
  return (
    <div className="flex flex-grow gap-s">
      {content.map((item, index) => (
        <div
          key={`col-${index}`}
          className="flex flex-1 flex-col items-center justify-start"
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export const VDPChargingBatteryCapacityCard: FC<
  VDPChargingBatteryCapacityCardProps
> = ({ capacity, fuelType, infoCircle }) => {
  const capacityRating = getBatteryCapacityRating(fuelType, capacity);

  return (
    <VDPChargingCardWrapper
      title={'Battery Capacity'}
      infoCircle={infoCircle}
      value={`${capacity || 'N/A'} kWh`}
      subtitle={`How much energy this ${fuelType === 'Electric' ? 'EV' : 'PHEV'} can hold.`}
      content={
        <div className="flex flex-col">
          <Columns
            content={['low', 'mlow', 'average', 'mhigh', 'high'].map((x) => {
              if (x === capacityRating) {
                return (
                  <Indicator
                    key={`range-value-${x}`}
                    title={`${capacity} kWh`}
                  />
                );
              }
              return null;
            })}
          />
          <Columns
            content={[
              <div
                key={'battery-range-low'}
                className="flex h-s w-full rounded-full bg-[#94DBFF]"
              />,
              <div
                key={'battery-range-mlow'}
                className="flex h-s w-full rounded-full bg-[#57A0EF]"
              />,
              <div
                key={'battery-range-average'}
                className="flex h-s w-full rounded-full bg-blue-medium"
              />,
              <div
                key={'battery-range-mhigh'}
                className="flex h-s w-full rounded-full bg-[#1950A3]"
              />,
              <div
                key={'battery-range-high'}
                className="flex h-s w-full rounded-full bg-[#0E326A]"
              />,
            ]}
          />
          <div>
            <Columns
              content={[
                <div
                  key={'driving-range-low'}
                  className="text-microMedium text-neutral-800"
                >
                  Low
                </div>,
                null,
                <div
                  key={'driving-range-average'}
                  className="text-microMedium text-neutral-800"
                >
                  Average
                </div>,
                null,
                <div
                  key={'driving-range-high'}
                  className="text-microMedium text-neutral-800"
                >
                  High
                </div>,
              ]}
            />
          </div>
        </div>
      }
    />
  );
};
